import type { ReactStoryblokComponent } from "types/storyblok";
import type { OurTeamProps } from "modules/sections/AboutUs/OurTeam";
import { OurTeam } from "modules/sections/AboutUs/OurTeam";

const OurTeamSectionAdapter = ({
  blok: { subHeading, title, subtitle, cards },
}: ReactStoryblokComponent<OurTeamProps>) => (
  <OurTeam subHeading={subHeading} title={title} subtitle={subtitle} cards={cards} />
);
export default OurTeamSectionAdapter;
